































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import LPFarm from '@/components/LPFarm.vue';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import Squad from '@/components/Squad.vue';
import ScarfFarm from '@/components/ScarfFarm.vue';
import { validateAccount } from '@/utils/web3';
import { ROUTE_FARM_TAB } from '@/router';

@Component({
  components: {
    AlpacaBtn,
    Squad,
    ScarfFarm,
    LPFarm,
  },
})
export default class Farm extends Vue {
  @Prop({
    required: false,
    default: 'uniswapV2',
  })
  public tab!: 'uniswap' | 'uniswapV2' | 'squad' | 'scarf';

  public curTab: 'uniswap' | 'uniswapV2' | 'squad' | 'scarf' = 'uniswap';

  get account() {
    return this.$store.getters.getAccount;
  }

  public mounted() {
    this.curTab = this.tab;
  }

  public changeTab(tab: 'uniswap' | 'uniswapV2' | 'squad' | 'scarf') {
    this.curTab = tab;
    this.$router.push({ name: ROUTE_FARM_TAB, params: {tab} });
  }

  public async connectWallet() {
    await validateAccount(this);
  }


}
